// extracted by css-extract-rspack-plugin
export default {"cookiePreferences":"_22bf4652"};